import * as React from "react";
import Svg, { Path } from "react-native-svg";

const BloodSugarGraphIcon = ({ tintColor = "#5C697B", ...props }) => {
  return (
    <Svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M1 1v14a1 1 0 001 1h14"
        stroke={tintColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15 5l-5 5-2.5-2.5L4 11"
        stroke={tintColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default BloodSugarGraphIcon;
